import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../data/reducers';
import * as assets from '../../assets/assets';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { restoreCart } from '../../data/reducers/cart.reducer';
import * as storeActions from '../../data/reducers/store.reducer';
import { AppDispatch } from '../../data/storeConfig';
import { ProductCategoryWithCount } from '../../data/models/product_list_response';
import authReducer, * as authActions from '../../data/reducers/auth.reducer';
import { getStoreSlug } from '../../utility/common';
import { Helmet } from 'react-helmet';

type NavigationShellProps = {
  children: React.ReactElement;
  title?: string;
  isBackVisible?: boolean;
};

import { Sidenav, Collapse, initTE } from 'tw-elements';

initTE({ Sidenav, Collapse });

export const NavigationShell = (props: NavigationShellProps) => {
  const { storeSlug } = useParams<any>();
  const navigate = useNavigate();
  const { cartItemCount } = useSelector((rootState: RootState) => rootState.cartReducer);
  const { storeInfo, storeProductCategories } = useSelector((rootState: RootState) => rootState.storeReducer);
  const { isLoggedIn } = useSelector((rootState: RootState) => rootState.authReducer);
  const dispatch = useDispatch<AppDispatch>();

  const [showNav, setShowNav] = React.useState(false);

  const logout = () => {
    dispatch(authActions.logout({ storeSlug: storeSlug ?? 'invalid-store-slug' }));
    navigate(`/${storeSlug}`);
  };

  useEffect(() => {
    if (storeSlug) {
      dispatch(storeActions.fetchStoreInfo({ storeSlug: storeSlug }));
      dispatch(restoreCart({ storeSlug: storeSlug }));
      dispatch(storeActions.fetchStoreProductCategories({ storeSlug: storeSlug }));
    }
    initTE({ Sidenav, Collapse });
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{`yufin | ${storeInfo?.storeName}`}</title>
        <meta name="description" content={storeInfo?.storeCategory?.storeCategoryName} />
        <link rel="canonical" href={storeInfo?.storeURL} />
      </Helmet>
      <ToastContainer transition={Slide} />
      <nav
        className="
        z-50
        fixed-top
  w-full
  flex flex-wrap
  items-center
  justify-between
  py-4
  bg-primaryViolet
  text-theLightOne
  hover:text-white
  focus:text-white
  shadow-lg navbar-light
  "
      >
        <div className="container-fluid w-full flex flex-wrap items-center justify-between px-6 md:w-2/4 mx-auto">
          <div className="block">
            {props.isBackVisible ? (
              <button
                className="inline-block bg-transparent text-white font-medium text-xs align-middle"
                onClick={() => history.back()}
              >
                <img src={assets.icons.BackIcon} />
              </button>
            ) : (
              <button
                className="inline-block bg-transparent text-white font-medium text-xs"
                data-te-sidenav-toggle-ref
                data-te-target="#sidenav-1"
                aria-controls="#sidenav-1"
                aria-haspopup="true"
              >
                <img src={assets.icons.MenuIcon} />
              </button>
            )}

            <nav
              id="sidenav-1"
              className="absolute left-0 top-0 z-[1035] h-full w-60 -translate-x-full overflow-hidden bg-primaryViolet shadow-[0_4px_12px_0_rgba(0,0,0,0.07),_0_2px_4px_rgba(0,0,0,0.05)] data-[te-sidenav-hidden='false']:translate-x-0"
              data-te-sidenav-init
              data-te-sidenav-hidden="true"
              data-te-sidenav-position="absolute"
            >
              {/* <div className="offcanvas-header flex items-center justify-between p-4">
                <h5 className="offcanvas-title mb-0 leading-normal font-semibold" id="offcanvasExampleLabel"></h5>
                
              </div> */}

              <ul className="text-left mt-12">
                <Link to={`/${storeSlug}`}>
                  <li
                    className="cursor-pointer hover:bg-white hover:bg-opacity-5 hover:text-white transition-colors"
                    data-bs-dismiss="offcanvas"
                    data-te-sidenav-toggle-ref
                    data-te-target="#sidenav-1"
                    aria-controls="#sidenav-1"
                    aria-haspopup="true"
                  >
                    <div className="py-4 mx-8 font-medium border-b border-b-theLightOne border-opacity-10">Home</div>
                  </li>
                </Link>
                <li className="bg-primaryViolet mx-3">
                  <h2 className="accordion-header mb-0" id="headingThree">
                    <button
                      className="group relative flex w-full items-center border-0 bg-transparent text-white px-5 py-4 text-left text-base transition [overflow-anchor:none] hover:z-[2] focus:z-[3] focus:outline-none [&:not([data-te-collapse-collapsed])]:bg-white [&:not([data-te-collapse-collapsed])]:text-primary [&:not([data-te-collapse-collapsed])]:[box-shadow:inset_0_-1px_0_rgba(229,231,235)] [&[data-te-collapse-collapsed]]:rounded-b-[15px] [&[data-te-collapse-collapsed]]:transition-none"
                      type="button"
                      data-te-collapse-init
                      data-te-collapse-collapsed
                      data-te-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Browse categories
                      <span className="-mr-1 ml-auto h-5 w-5 shrink-0 rotate-[-180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:mr-0 group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#212529] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="h-6 w-6"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                        </svg>
                      </span>
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="!visible hidden"
                    data-te-collapse-item
                    aria-labelledby="headingThree"
                    data-te-parent="#accordionExample"
                  >
                    <div className="px-5 py-4">
                      {storeProductCategories?.map((category: ProductCategoryWithCount) => (
                        <Link
                          to={`/${storeSlug}/category/${category.productCategoryId}`}
                          key={category.productCategoryId}
                        >
                          <li
                            className="cursor-pointer hover:bg-white hover:bg-opacity-5 hover:text-white transition-colors"
                            data-bs-dismiss="offcanvas"
                            data-te-sidenav-toggle-ref
                            data-te-target="#sidenav-1"
                            aria-controls="#sidenav-1"
                            aria-haspopup="true"
                          >
                            <div className="py-4 mr-8 ml-14 font-medium border-b border-b-theLightOne border-opacity-10">
                              {category.productCategoryName}
                            </div>
                          </li>
                        </Link>
                      ))}
                    </div>
                  </div>
                </li>

                <Link to={`/${storeSlug}/orders`}>
                  <li
                    className="cursor-pointer hover:bg-white hover:bg-opacity-5 hover:text-white transition-colors"
                    data-bs-dismiss="offcanvas"
                    data-te-sidenav-toggle-ref
                    data-te-target="#sidenav-1"
                    aria-controls="#sidenav-1"
                    aria-haspopup="true"
                  >
                    <div className="py-4 mx-8 font-medium border-b border-b-theLightOne border-opacity-10">Orders</div>
                  </li>
                </Link>
                {/* <li className="cursor-pointer hover:bg-white hover:bg-opacity-5 hover:text-white transition-colors"  data-te-sidenav-toggle-ref
                data-te-target="#sidenav-1"
                aria-controls="#sidenav-1"
                aria-haspopup="true">
                  <div className="py-4 mx-8 font-medium border-b border-b-theLightOne border-opacity-10">Settings</div>
                </li> */}
                {isLoggedIn ? (
                  <li className="cursor-pointer hover:bg-white hover:bg-opacity-5 hover:text-white transition-colors">
                    <div
                      className="py-4 mx-8 font-medium border-b border-b-theLightOne border-opacity-10"
                      onClick={logout}
                      data-te-sidenav-toggle-ref
                      data-te-target="#sidenav-1"
                      aria-controls="#sidenav-1"
                      aria-haspopup="true"
                    >
                      Log out
                    </div>
                  </li>
                ) : (
                  <Link to={`/${storeSlug}/login?redirectTo=/${storeSlug}`}>
                    <li
                      className="cursor-pointer hover:bg-white hover:bg-opacity-5 hover:text-white transition-colors"
                      data-te-sidenav-toggle-ref
                      data-te-target="#sidenav-1"
                      aria-controls="#sidenav-1"
                      aria-haspopup="true"
                    >
                      <div className="py-4 mx-8 font-medium border-b border-b-theLightOne border-opacity-10">Login</div>
                    </li>
                  </Link>
                )}
              </ul>
            </nav>
          </div>

          {/* <div className="collapse navbar-collapse flex-grow items-center" id="navbarSupportedContent">
            <ul className="navbar-nav flex flex-col pl-0 list-style-none mr-auto">
              <li className="nav-item p-2">
                <a className="nav-link text-white hover:text-theLightOne focus:text-theLightOne p-0" href="#">
                  Home
                </a>
              </li>
              <li className="nav-item p-2">
                <a className="nav-link text-white hover:text-theLightOne focus:text-theLightOne p-0" href="#">
                  Products
                </a>
              </li>
            </ul>
          </div> */}

          <div className="w-max mx-auto">{props.title ?? storeInfo?.storeName}</div>

          <div className="flex items-center relative">
            {storeInfo?.pickupAvailable || storeInfo?.deliveryAvailable ? (
              <Link className="text-white hover:text-theLightOne focus:text-theLightOne" to={`/${storeSlug}/cart`}>
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="shopping-cart"
                  className="w-4 relative"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 576 512"
                >
                  <path
                    fill="currentColor"
                    d="M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
                  ></path>
                </svg>
                <span className="text-primaryViolet absolute top-1 left-0 bg-white rounded-full text-xs -mt-2.5 ml-2 py-0 px-1.5">
                  {cartItemCount}
                </span>
              </Link>
            ) : (
              <></>
            )}
            {/* <div className="dropdown relative"></div> */}
            {/* <div className="dropdown relative">
              <a
                className="dropdown-toggle flex items-center hidden-arrow"
                href="#"
                id="dropdownMenuButton2"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src="https://mdbootstrap.com/img/new/avatars/2.jpg"
                  className="rounded-full h-6 w-6"
                  alt=""
                  loading="lazy"
                />
              </a>
              <ul
                className="
    dropdown-menu
    min-w-max
    absolute
    hidden
    bg-white
    text-base
    z-50
    float-left
    py-2
    list-none
    text-left
    rounded-lg
    shadow-lg
    mt-1
    m-0
    bg-clip-padding
    border-none
    left-auto
    right-0
  "
                aria-labelledby="dropdownMenuButton2"
              >
                <li>
                  <a
                    className="
        dropdown-item
        text-sm
        py-2
        px-4
        font-normal
        block
        w-full
        whitespace-nowrap
        bg-transparent
        text-gray-700
        hover:bg-gray-100
      "
                    href="#"
                  >
                    Profile
                  </a>
                </li>
                <li>
                  <a
                    className="
        dropdown-item
        text-sm
        py-2
        px-4
        font-normal
        block
        w-full
        whitespace-nowrap
        bg-transparent
        text-gray-700
        hover:bg-gray-100
      "
                    href="#"
                  >
                    Order history
                  </a>
                </li>
              </ul>
            </div> */}
          </div>
        </div>
      </nav>
      <div className="pt-14 md:w-2/4 mx-auto overflow-y-auto">{props.children}</div>
    </div>
  );
};
